// MT — scripts vanilla para landing y producto. Sin librerías externas.

function mtInitReveal() {
  var items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  items.forEach(function (el) { observer.observe(el); });
}

function mtInitFaq() {
  var faqItems = document.querySelectorAll('.mt-faq-item');
  if (!faqItems.length) return;
  faqItems.forEach(function (item) {
    var btn = item.querySelector('.mt-faq-q');
    var answer = item.querySelector('.mt-faq-a');
    if (!btn || !answer) return;
    btn.addEventListener('click', function () {
      var isOpen = item.getAttribute('data-open') === 'true';
      faqItems.forEach(function (other) {
        other.setAttribute('data-open', 'false');
        var a = other.querySelector('.mt-faq-a');
        if (a) a.style.maxHeight = null;
      });
      if (!isOpen) {
        item.setAttribute('data-open', 'true');
        answer.style.maxHeight = answer.scrollHeight + 40 + 'px';
      }
    });
  });
}

function mtInitCountUp() {
  var stats = document.querySelectorAll('[data-mt-count]');
  if (!stats.length) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseFloat(el.getAttribute('data-mt-count')) || 0;
        var suffix = el.getAttribute('data-mt-suffix') || '';
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = Math.round(target * eased);
          el.textContent = value + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.5 }
  );
  stats.forEach(function (el) { observer.observe(el); });
}

function mtInitGallery() {
  var galleries = document.querySelectorAll('[data-mt-gallery]');
  galleries.forEach(function (gallery) {
    var mainImgs = gallery.querySelectorAll('.mt-gallery-main img');
    var thumbs = gallery.querySelectorAll('.mt-gallery-thumb');
    if (!mainImgs.length) return;

    function showIndex(idx) {
      idx = String(idx);
      thumbs.forEach(function (t) { t.classList.toggle('mt-active', t.getAttribute('data-index') === idx); });
      mainImgs.forEach(function (img) { img.classList.toggle('mt-active', img.getAttribute('data-index') === idx); });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showIndex(thumb.getAttribute('data-index'));
      });
    });

    var mainEl = gallery.querySelector('.mt-gallery-main');
    if (mainEl) {
      var touchStartX = 0;
      mainEl.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      mainEl.addEventListener('touchend', function (e) {
        var diff = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(diff) < 40) return;
        var current = mainEl.querySelector('.mt-active');
        var currentIdx = current ? parseInt(current.getAttribute('data-index'), 10) : 0;
        var total = mainImgs.length;
        var nextIdx = diff < 0 ? (currentIdx + 1) % total : (currentIdx - 1 + total) % total;
        showIndex(nextIdx);
      }, { passive: true });
    }
  });
}

function mtInitVariantPicker() {
  var forms = document.querySelectorAll('[data-mt-product-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variants]');
    if (!dataEl) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var swatches = form.querySelectorAll('.mt-variant-swatch');
    var idInput = form.querySelector('input[name="id"]');
    var priceNow = form.querySelector('.mt-price-now');
    var priceWas = form.querySelector('.mt-price-was');
    var priceSave = form.querySelector('.mt-price-save');
    var addBtn = form.querySelector('.mt-add-btn');
    var galleryRoot = document.querySelector('[data-mt-gallery]');

    function money(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function selectVariant(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = money(variant.price);
      if (priceWas && priceSave) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = money(variant.compare_at_price);
          priceWas.style.display = '';
          var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          priceSave.textContent = '-' + pct + '%';
          priceSave.style.display = '';
        } else {
          priceWas.style.display = 'none';
          priceSave.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.querySelector('.mt-add-btn-text').textContent = variant.available
          ? addBtn.getAttribute('data-text-available')
          : addBtn.getAttribute('data-text-sold-out');
      }
      if (variant.featured_media && galleryRoot) {
        var mainImg = galleryRoot.querySelector(
          '.mt-gallery-main img[data-media-id="' + variant.featured_media.id + '"]'
        );
        var thumb = galleryRoot.querySelector(
          '.mt-gallery-thumb[data-media-id="' + variant.featured_media.id + '"]'
        );
        if (mainImg && thumb) {
          galleryRoot.querySelectorAll('.mt-gallery-main img').forEach(function (i) { i.classList.remove('mt-active'); });
          galleryRoot.querySelectorAll('.mt-gallery-thumb').forEach(function (t) { t.classList.remove('mt-active'); });
          mainImg.classList.add('mt-active');
          thumb.classList.add('mt-active');
        }
      }
    }

    function currentSelection() {
      var selected = {};
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var active = group.querySelector('.mt-variant-swatch.mt-selected');
        if (active) selected[group.getAttribute('data-option-index')] = active.getAttribute('data-value');
      });
      return variants.find(function (v) {
        return Object.keys(selected).every(function (idx) {
          var numericIndex = parseInt(idx.replace('option', ''), 10);
          return v.options[numericIndex] === selected[idx];
        });
      });
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.disabled) return;
        var group = swatch.closest('[data-option-index]');
        group.querySelectorAll('.mt-variant-swatch').forEach(function (s) { s.classList.remove('mt-selected'); });
        swatch.classList.add('mt-selected');
        var variant = currentSelection();
        if (variant) selectVariant(variant);
      });
    });

    var qtyInput = form.querySelector('.mt-qty-input');
    form.querySelectorAll('.mt-qty-minus, .mt-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var val = parseInt(qtyInput.value, 10) || 1;
        val = btn.classList.contains('mt-qty-plus') ? val + 1 : Math.max(1, val - 1);
        qtyInput.value = val;
      });
    });

    var buyNowBtn = form.querySelector('.mt-buy-now-btn');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        buyNowBtn.disabled = true;
        var originalText = buyNowBtn.textContent;
        buyNowBtn.textContent = '...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: idInput.value,
            quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add to cart failed');
            window.location.href = '/checkout';
          })
          .catch(function () {
            buyNowBtn.disabled = false;
            buyNowBtn.textContent = originalText;
            window.location.href = '/cart';
          });
      });
    }
  });
}

function mtInitTiltCards() {
  if (window.matchMedia('(pointer: coarse)').matches) return;
  var cards = document.querySelectorAll('.mt-card, .mt-paso');
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(700px) rotateY(' + (x * 4) + 'deg) rotateX(' + (y * -4) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveal();
  mtInitFaq();
  mtInitCountUp();
  mtInitGallery();
  mtInitVariantPicker();
  mtInitTiltCards();
});
